// Port of api/fuel/app/classes/filter/search/games/filters/query/other/designers.php
import DB from 'offline/db'
import Util from 'offline/util'
export default {
	name: 'other.designers',
	priority: 70,
	require: function(config, filter) {
		return filter.designers && filter.designers.length > 0
	},
	run: function(config, filter, data, query) {
		var include = [], exclude = []
		for (var i = 0; i < filter.designers.length; i++) {
			var d = filter.designers[i]
			if (d < 0) exclude.push(-d)
			else include.push(d)
		}
		if (include.length) {
			var games = DB.query('SELECT DISTINCT game_id AS g FROM game_designer WHERE designer_id IN(' + Util.in(include) + ')')
			var ids = Util.pluck(games, 'g')
			if (ids.length) query.where('g.game_id', 'in', ids)
		}
		if (exclude.length) {
			var exGames = DB.query('SELECT DISTINCT game_id AS g FROM game_designer WHERE designer_id IN(' + Util.in(exclude) + ')')
			var exIds = Util.pluck(exGames, 'g')
			if (exIds.length) query.where('g.game_id', 'not in', exIds)
		}
	}
}
